import { render, staticRenderFns } from "./addPurchaseRequisition.vue?vue&type=template&id=612af40c&scoped=true"
import script from "./addPurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./addPurchaseRequisition.vue?vue&type=script&lang=js"
import style0 from "./addPurchaseRequisition.vue?vue&type=style&index=0&id=612af40c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612af40c",
  null
  
)

export default component.exports